import React from "react";
import UploadCsv from "./components/UploadCsv";

function App() {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>CSV Data-Cleaning Copilot</h1>
      <UploadCsv />
    </div>
  );
}

export default App;
